import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 実力テスト成績詳細取得（Tコース）
 */
export namespace ApiTaRe020 {
  // API Name
  export const name: string = 'ApiTaRe020'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/testRecord'

    export interface Request {
      query: {
        testYear: number
        testMonth: number
        times?: number
        grade: number
      }
    }

    export interface Response {
      gradeData: {
        memNum: string
        title: string
        results: {
          subjectCode: string
          answerId: string
          score: string
          rankinFlag: number
          ranking: string
          average: string
          deviationValue: string
        }[]
      }
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        gradeData: {
          memNum: '',
          title: '',
          results: [
            {
              subjectCode: '',
              answerId: '',
              score: '',
              rankinFlag: 0,
              ranking: '',
              average: '',
              deviationValue: '',
            },
          ],
        },
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
